export const getLocalProgress = (client, uuid) => {
    const localProgress = client.getQueriesData({
        predicate: (query) => {
            const key = query.queryKey;
            if (!key || key[0] !== `progress`)
                return false;
            const data = query.state?.data;
            if (key?.[1]?.contentId !== undefined &&
                key?.[1]?.uuid === uuid &&
                data?.staleAt !== undefined) {
                return true;
            }
            return false;
        },
    });
    return localProgress;
};
//# sourceMappingURL=getLocalProgress.js.map